import { ApiConfigPropTypes } from '@airtel/air-artist/lib/components/renderer';
import { getFromSessionStorage } from '../utils/CommonUtils';

export const LOGIN_CONSTANTS = {
   staticToken: 'static-token',
   dynamicToken: 'dynamic-token',
   uid: 'uid',
   loggedInUser: 'aa-auk',
   authKey: '',
   groupId: 'SKYC_REVERIFICATION',
};

export const queryParams = {
   utmLayout: 'utm_layout',
};

export const PREPAID_LAYOUT = "prepaid_sim";
export const COCP_TO_RETAIL_LAYOUT = "cocp_to_retail"
export const COCP = "cocp"
export const Variant_2 = "variant_2"
export const PREPAID_SIM_LAYOUT = "prepaid_sim_layout";
export const SKYC_REVAMP_LAYOUT = "skyc_revamp";
export const SKYC_REVAMP_MIDDLE_LAYOUT = "Layout_1";

export const PUBLIC_KEY_URL =
   'https://assets.airtel.in/static-assets/airtel-lite/files/cert.pem';

const APP_ENVIRONMENT: any = {
   PRODUCTION: {
      baseUrl: 'https://digi-api.airtel.in/v2/',
      environment: 'PRODUCTION',
   },
   TND: {
      baseUrl: 'https://kongqa.airtel.com/web-tnd/',
      environment: 'STAGING',
    },
   AUTOMATION: {
      baseUrl: 'https://kongqa.airtel.com/web-automation/',
      environment: 'STAGING',
   },
   PREPROD: {
      baseUrl: 'https://kongqa.airtel.com/web-preprod/',
      environment: 'PREPROD',
   },
   QA: {
      baseUrl: 'https://kongqa.airtel.com/acquisition/v2/',
      environment: 'STAGING',
   },
   PORTFOLIO: {
      baseUrl: 'https://kongqa.airtel.com/web-qa/',
      environment: 'STAGING',
   }
   
};

const getQueryString = () => {
   let queryString: any = (window && window.location && window.location.search) || '';
   let resultObj: any = {};
   queryString = queryString.substring(1);
   queryString = queryString.split('&');
   queryString.forEach((keyVal: any) => {
      let key = keyVal.substring(0, keyVal.indexOf('='));
      let value = keyVal.substring(keyVal.indexOf('=') + 1);
      resultObj[key] = value;
   });
   return resultObj;
};

const getApiEnvConfig = () => {
   let config = APP_ENVIRONMENT.PRODUCTION; // change for default config
   const { apiType, apiEnvType } = getQueryString();

   // to bypass api type
   if (apiType) config = APP_ENVIRONMENT[apiType];
   if (apiEnvType) config.environment = apiEnvType;

   return config;
};

export const API_CONFIGS: ApiConfigPropTypes = {
   appName: 'acq-skyc',
   ...getApiEnvConfig(),
   requestInterceptor: function (config: any) {
      //@ts-ignore
      const state = window?.store?.getState()
      let consumerLob = state?.storeValues?.appData?.lob
      const pathName = window?.location?.pathname
      if(pathName?.includes("kyc/reverification")){
         consumerLob = 'CUSTOMER_REVERIFICATION'
      }
      config.headers['x-consumer-lob'] = sessionStorage?.getItem("consumerLob") || consumerLob;         
      return config;
   },
};

export const getCurrentJourney = ()=>{
 let pathName = window?.location?.pathname
 if(pathName?.includes("kyc/reverification")){
   return "skyc-reverification"
 }
 return "skyc-new"
}

export const isRevampJourneyPhoto = (): boolean => {
   return window.location.href.toLowerCase().includes('selfie');
};